// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"d7a5bae3","303":"90753ac6","338":"8fd00220","394":"1b081575","396":"4b02a3b5","607":"c113ea8e","675":"f8d13ce7"}[chunkId] + ".chunk.js";
};